import React from 'react'
import { component_tool, framework_tool } from '@/tool';
let { WizContainer } = framework_tool;
import { Layout, Tabs, Dropdown, Button, Menu, Icon } from 'antd';

import moment from "moment";
import { WizTableForm } from '@/containers/common'
import NewVersion from './newVersion'
import './index.less'
import BatchUpdate from './batchUpdate';
import UpdateSort from './updateSort';
let { WizRow, WizCol, WizCheckbox, WizTag, WizInput, WizInputNumber, WizRadio, WizModal,WizPopover } = component_tool;
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const proKnowledgeTypeConfig = WizTableForm.Config.proKnowledgeType(this, { apiParams: {  } });
const labelConfig = WizTableForm.Config.label(this, { apiParams: { type: 6, name: '产品知识库标签' } })
const brandConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})

let ref;

//配置项
let componentName = 'proKnowledge'

// this.batchAuditRecord = (record, _this) => {
//   _this.doAction({
//     path: 'proKnowledge/batchUpdate',
//     payload: {
//       key: 'proKnowledge@batchUpdate',
//       apiParams: {
//         ...record
//       }
//     }
//   })
// }

const columns = [
  {
    title: "标题",
    name: "title",
    dataIndex: "title",
    searchItem: {},
    formItem: {},
    tableItem: {}
  },

  {
    title: "知识类型",
    name: "proKnowledgeTypeTitle",
    dataIndex: "proKnowledgeTypeTitle",
    tableItem: {}
  },
  {
    title: "知识类型",
    name: "proKnowledgeTypeIdList",
    searchItem: {
      ...proKnowledgeTypeConfig,
      diy: WizTableForm,
    }
  },
  {
    title: "分类",
    name: "categoryStr",
    dataIndex: "categoryStr",
    formItem: {},
    tableItem: {
      render: (text,record) =>{
        let contextList = text && text.split(';').length ? text.split(';') : []
        let content = [];
        let title = ''
        contextList && contextList.length && contextList.map((d,index) => {
          if (index === 0) {
            title = d
          }
          content.push(<p>{d}</p>)
        })
        let _titleView = []
        _titleView.push(title)
        if(contextList && contextList.length > 1){
          _titleView.push(<span className='wiz-press-font-color'> ...</span>)
        }
        return (
          <WizPopover content={content} placement="rightTop">
            {_titleView}
          </WizPopover>
        )
      }
    }
  },
  {
    title: "标签",
    name: "labelIdList",
    dataIndex: "labelIdList",
    searchItem: {
      ...labelConfig,
      diy: WizTableForm,
    },
  },
  {
    title: "标签",
    name: "labelStr",
    dataIndex: "labelStr",
    tableItem: {}
  },
  {
    title: "作者",
    name: "author",
    dataIndex: "author",
    formItem: {},
    searchItem: {},
    tableItem: {}
  },
  {
    title: "所属组织",
    name: "belongOrg",
    dataIndex: "belongOrg",
    formItem: {},
    tableItem: {},
    searchItem:{}
  },
  {
    title: "品牌",
    name: "brandName",
    dataIndex: "brandName",
    formItem: {},
    tableItem: {},
  },
  {
    title: "功能块",
    name: "module",
    dataIndex: "module",
    formItem: {},
    tableItem: {},
    dict :[
      { code: 0, codeName: "销售" },
      { code: 1, codeName: "售后服务" },
      { code: 2, codeName: "售后技术" },
      { code: 3, codeName: "诚新二手车" },
      { code: 4, codeName: "校企合作" },
      { code: 5, codeName: "集团销售" },
      { code: 9, codeName: "跨业务块" },
    ]
  },
  // {
  //   title: "所属组织",
  //   name: "orgIdList",
  //   searchItem: {
  //     ...organizationConfig,
  //     diy: WizTableForm,
  //   }
  // },
  {
    title: "生效时间",
    name: "effectiveTimeAll",
    dataIndex: "effectiveTimeAll",
    formItem: {},
    searchItem: {
      type: 'date~',
      showTime: true
    },
  },
  {
    title: "生效时间",
    name: "effectiveTime",
    dataIndex: "effectiveTime",
    formItem: {},
    tableItem: {}
  },
  {
    title: "失效时间",
    name: "failureTimeAll",
    dataIndex: "failureTimeAll",
    formItem: {},
    searchItem: {
      type: 'date~',
      showTime: true
    },
  },
  {
    title: "失效时间",
    name: "failureTime",
    dataIndex: "failureTime",
    formItem: {},
    tableItem: {}
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "草稿" },
      { code: 2, codeName: "已发布" },
      { code: 3, codeName: "已过期" },
      { code: 4, codeName: "已关闭" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    formItem: {
      type: "select"
    }
  },
  {
    title: "发布终端",
    name: "releasePlatform",
    dataIndex: "releasePlatform",
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    dict: [
      { code: 1, codeName: "PC" },
      { code: 2, codeName: "APP" },
      { code: 3, codeName: "凯迪拉克IQ" },
     // { code: 4, codeName: "小程序" },
      { code: 5, codeName: "雪佛兰企微" },
      { code: 6, codeName: "别克企微" },
      { code: 7, codeName: "凯迪拉克企微" },
    ]
  },
  {
    title: "发布终端",
    name: "releasePlatformStr",
    dataIndex: "releasePlatformStr",
    tableItem: {},
  },

  {
    title: "添加水印",
    name: "watermark",
    dataIndex: "watermark",
    tableItem: {},
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    dict: [
      { code: 1, codeName: "是" },
      { code: 0, codeName: "否" }
    ]
  },
  {
    title: "允许下载",
    name: "download",
    dataIndex: "download",
    tableItem: {},
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    dict: [
      { code: 1, codeName: "是" },
      { code: 0, codeName: "否" }
    ]
  },
  {
    title: "阅读量",
    name: "readTotal",
    dataIndex: "readTotal",
    formItem: {},
    tableItem: {}
  },
  {
    title: "点赞量",
    name: "likeTotal",
    dataIndex: "likeTotal",
    formItem: {},
    tableItem: {}
  },
  {
    title: "收藏量",
    name: "collectTotal",
    dataIndex: "collectTotal",
    formItem: {},
    tableItem: {}
  },
  {
    title: "排序号",
    name: "sort",
    dataIndex: "sort",
    formItem: {},
    tableItem: {}
  },
  {
    title: "品牌",
    name: "brandId",
    dataIndex: "brandId",
    formItem: {},
    searchItem: {
      ...brandConfig,
      diy: WizTableForm,
      selectType: 'radio',
    }
  },
  {
    title: "功能块",
    name: "module",
    dataIndex: "module",
    formItem: {},
    searchItem:{type: "select"},
    dict :[
      { code: 0, codeName: "销售" },
      { code: 1, codeName: "售后服务" },
      { code: 2, codeName: "售后技术" },
      { code: 3, codeName: "诚新二手车" },
      { code: 4, codeName: "校企合作" },
      { code: 5, codeName: "集团销售" },
      { code: 9, codeName: "跨业务块" },
    ]
  },
];

const templateConfig = (bts, _this) => {
  let btNew = <Dropdown overlay={<Menu>{bts}</Menu>}>
    <div>
      新增知识
      <Icon type="down" />
    </div>
  </Dropdown>
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        //  btnAccessCheck:false,
        searchBarProps: {
          collapse: true,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            let effectiveTimeAll = value.effectiveTimeAll;
            if (effectiveTimeAll && effectiveTimeAll.length === 2) {
              value.effectiveTimeStart = moment(effectiveTimeAll[0]).format('YYYY-MM-DD HH:mm:ss')
              value.effectiveTimeEnd = moment(effectiveTimeAll[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            let failureTimeAll = value.failureTimeAll;
            if (failureTimeAll && failureTimeAll.length === 2) {
              value.failureTimeStart = moment(failureTimeAll[0]).format('YYYY-MM-DD HH:mm:ss')
              value.failureTimeEnd = moment(failureTimeAll[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            return value
          },
          buttonSort: ['add', 'export', 'batchSet'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { children: btNew },
              customOnClick: {
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            },
            {
              key: 'batchSet',
              custom: true,
              params: { children: '批量修改' },
              needSelect: true,
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '批量修改',
                    destroyOnClose: true,
                    width: 800,
                    centered: true,
                     diy: (e) => {
                      // _this.changeModal = e.changeModal
                       let record = e && e.rows
                      // _this.setState({ record: record })
                       return <BatchUpdate  {...e} record={record} 
                       ref={(r) => {
                        ref = r && r.getWrappedInstance()
                      }}
                       />
                    },
                    onOk: (e) => {
                      ref._onOk();
                    },
                    onCancel: () => {
                      ref._onCancel();
                    }
                  }
                }
              },
              recordChangeParams: ({ record, rows }) => {
                return {}
              }
            },
          ]
        },
        siderBarProps: {
          searchKey: "categoryId",
          otherProps: {
            key: "typeNodeList"
          },
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "",
              children: ""
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'enableOrDisable','newVersion','recordManagement','updateSort'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/proKnowledge/knowledgeBaseList/knowledgeBaseDetailLook"
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/proKnowledge/knowledgeBaseList/knowledgeBaseDetailUpd"
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "发布" },
            textFormat: {
              recordKey: 'state',
              dirt: { 4: '发布', 2: '关闭' ,1:'发布',3:'关闭'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState"
              },
              formatParams: (rows, record, filters, callback) => {
                let content = "";
                switch (record.state) {
                  case 1:
                    state = 2,
                    content = "发布"
                    break;
                  case 2:
                    state = 4,
                    content = "关闭"
                    break;
                  case 3:
                    state = 4,
                    content = "关闭"
                    break;
                  case 4:
                    state = 2,
                    content = "发布";
                    break;
                  default:
                    break;
                }
                WizModal.confirm({
                  title: '注意', 
                  content: '您确认'+content+'该知识吗?',
                  onOk: () => {
                    callback && callback({
                      state: state,
                      id: record['id'],
                    })
                  },
                  onCancel() { }
                });
                return null
              }
            }
          },
          {
            key: 'newVersion',
            custom: true,
            params: { children: '新版本' },
            //needSelect: true,
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'newVersion_' + new Date().getTime(),
                modalParams: {
                  title: '请选择知识点版本号',
                  style: {minWidth: 400},
                  destroyOnClose: true,
                  diy: (e) => {
                    return <NewVersion key={e.record.id} {...e}
                                          ref={(r) => {
                                            ref = r && r.getWrappedInstance();
                                          }}
                    />
                  },
                  onOk: () => {
                  },
                  onCancel: () => {
                  },
                  footer: false,
                  width: 400
                },
              },
            },
            recordChangeParams: ({ record, rows }) => {
              return {}
            }
          },
          {
            key: "recordManagement",
            custom: true,
            params: { children: "记录管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/proKnowledge/knowledgeBaseList/knowledgeRecordList"
              }
            }
          },
          {
            key: "updateSort",
            custom: true,
            params: { children: "调整排序号" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "调整排序号",
                  destroyOnClose: true,
                  diy: (e) => {
                    return (
                      <UpdateSort
                      // onChangeTimestamp={(e) => 
                      //   _this.setState({timestamp: new Date().getTime()})}
                      // key={'details' + e.record.id+new Date().getTime()}
                      key={'details' + e.record.id }
                      {...e}
                      />
                    )
                  },
                  onCancel: () => {
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
          },
        ],
        commonOperate: {
          add: true,
          delete: true
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@pageList`,
      apiParams: {}
    }
  },
  treeData: {
    path: `${componentName}/getCategoryList`,
    payload: {
      key: `${componentName}@getCategoryList`,
      apiParams: {}
    }
  },
  getProKnowledgeTypes: {
    path: `proKnowledgeType/export`,
    payload: {
      key: `proKnowledgeType@export`,
      apiParams: {
        state:1
      }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  batchUpdate: {
    path: `${componentName}/batchUpdate`,
    payload: {
      key: `${componentName}@batchUpdate`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData', 'getProKnowledgeTypes'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
